/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ToggleText = styled.span`
  text-transform: uppercase;
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 1px;
  color: #514f4d;
  padding-top: 3px;
  @media (max-width: 767px) {
    display: none;
  }
`;

const ToggleLabel = styled.span`
  text-transform: uppercase;
  font-size: 16px;
  line-height: 1.31;
  letter-spacing: 1.3px;
  color: #514f4d;
  display: none;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  @media (max-width: 767px) {
    display: block;
  }
`;

class ToggleComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    text: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func
  };

  onChange(event) {
    if (this.props.onChange) this.props.onChange(event.target.checked);
  }

  render() {
    const {
      id,
      name,
      text,
      value,
      className,
      checked,
      disabled,
      label
    } = this.props;

    return (
      <div className={className}>
        <div className="slds-form-element">
          <label className="slds-checkbox--toggle slds-grid">
            <ToggleText className="slds-form-element__label slds-m-bottom--none">
              {text}
            </ToggleText>
            <input
              type="checkbox"
              checked={checked}
              id={id || name}
              name={name}
              value={value}
              onChange={this.onChange}
              disabled={Boolean(disabled)}
              aria-describedby="toggle-desc"
            />
            <span
              id="toggle-desc"
              className="slds-checkbox--faux_container"
              aria-live="assertive"
            >
              <ToggleLabel>{label}</ToggleLabel>
              <span className="slds-checkbox--faux" />
            </span>
          </label>
        </div>
      </div>
    );
  }
}

export default ToggleComponent;
